module.exports = __webpack_public_path__ + "static/img/商务会展_0.b24cf5f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/商务会展_0.png
// module id = HCp0
// module chunks = 1